import { PaymentIntent } from '@stripe/stripe-js';

export const checkIsKonbiniPayment = (payment: Partial<PaymentIntent>) =>
  payment.payment_method_types[0] === 'konbini';
